// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"style_sidebar__20YO8","hidden":"style_hidden__1XlB_","logo":"style_logo__1e-ND","summary":"style_summary__3lUAu"};